import React from "react";
import "./servicesOverviewSection.css";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";

const ServicesOverviewSection = ({ data }) => {
    const {
        eyebrow,
        titleHighlight,
        BsTextParagraphHighlight,
        items,
        imageUrl,
        button:
        {
            text: btnText,
            // url: btnUrl
        }
    } = data;

    const midway = Math.ceil(items.length / 2);
    const leftItems = items.slice(0, midway);
    const rightItems = items.slice(midway);

    return (
        <section className="os-section">
            <div className="container os-section-container">

                <div className="row align-items-center os-row1">
                    <div className="col-12 col-md-6 os-head">
                        <h2 className="os-title line-height-clss">
                            <p className="os-eyebrow">{eyebrow}</p>
                            <span>{titleHighlight}</span>
                        </h2>
                        <p className="casper-normal">{BsTextParagraphHighlight}</p>
                    </div>
                    <div
                        className="col-12 col-md-6 os-image"
                        style={{ backgroundImage: `url(${imageUrl})` }}
                    />
                </div>
                <div className="row os-row2">
                    <div className="col-12 col-md-6 os-list-col">
                        {leftItems.map((it, i) => (
                            <div key={i} className="os-item">
                                <h3 className="os-item-title">{it.title}</h3>
                                <p className="os-item-desc casper-normal">{it.description}</p>
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-6 os-list-col">
                        {rightItems.map((it, i) => (
                            <div key={i} className="os-item">
                                <h3 className="os-item-title">{it.title}</h3>
                                <p className="os-item-desc casper-normal">{it.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="row os-row3">
                    <div className="col-12 text-center">
                        <Link to="/contact" className="os-button btn-general">
                            {btnText} <FaArrowRight className='card-arrow' /></Link>
                        <hr className="os-divider" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesOverviewSection;
